// create existence flag for each piece of store data
// makes it easier to debug timing issues in App.tsx

export const isTokenLoaded = state => !!state.user && !!state.user.accessToken;
export const getToken = state => state.user.accessToken;

export const isPermissionsLoaded = state => !!state.user && !!state.user.permissions;
export const getPermissions = state => state.user.permissions;
